
import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator';
import VehicleModule from '@/components/carModule/VehicleModule.vue';

@Component({
  components: {
    VehicleModule,
  },
})
export default class BrandCarSeriesModelsField extends Vue {
  name = 'NameField';
  val = '';

  @Ref()
  vehicleModule!: VehicleModule;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  form!: any;

  @Prop()
  value!: any;

  init() {
    this.vehicleModule.init();
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      if (this.value.brand && this.value.series && this.value.modelName) {
        this.val = `${this.value.brand}/${this.value.series}/${this.value.modelName}`;
      }
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }

  updateName(name: any) {
    this.val = `${name.brand}/${name.series}/${name.modelName}`;
    this.$emit('update', name);
    this.$emit('brandCarSeriesModels', name);
  }
}
